import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { categoryChangeStatusAPI, categoryCreateAPI, categoryDeleteAPI, categoryFullListAPI, categoryList, categoryListAPI, categoryUpdateAPI, logOutApi, vendorCreateAPI, vendorListAPI, countryListApi, stateListApi, vendorDeleteAPI, vendorUpdateAPI, vendorDetailsAPI, vendorChangeStatusAPI, inventoryCreateAPI, vendorFullListAPI, inventoryListAPI, inventoryGetAPI, inventoryUpdateAPI, inventoryUpdateStockAPI, StockHistoryListAPI, inventoryDownloadList, inventoryDeleteAPI } from '../../../Context/api';
import axios from 'axios';
import { commonMessage, roleNames, statusCodes } from '../../../Constants/generalConfig';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { environment } from '../../../Context/environment';

const useInventoryManagement = () => {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const [showModal, setShowModal] = useState(false)
  const [count, setCount] = useState(1)
  const [page, setPage] = useState(1)
  const PER_PAGE = 10
  const [mode, setMode] = useState('add');
  const [editingId, setEditingId] = useState(null);
  const [categoryFullList, setCategoryFullList] = useState([])
  const [vendorFullList, setVedndorFullList] = useState([])
  const [stateList, setStateList] = useState([])
  const [countryList, setCountryList] = useState([])
  const [selectedCountryId, setSelectedCountryId] = useState('');
  const [venderDetails, setVenderDetails] = useState({})
  const [inventoryDetails, setInventoryDetails] = useState({})
  const [historyCount, setHistoryCount] = useState(1)
  const [pageHistory, setPageHistroy] = useState(1)
  const [categoryCount, setCategoryCount] = useState(1)
  const [pageCategory, setPageCategory] = useState(1)
  const [vendorCount, setVendorCount] = useState(1)
  const [pageVendor, setPageVendor] = useState(1)
  const [stockModal, setStockModal] = useState({
    show: false,
    inventoryId: '',
    action: ''
  })
  const [stockForm, setStockForm] = useState({
    quantity: '',
  })

  const [inventorySearchFilter, setInventorySearchFilter] = useState({
    search: null
  })
  const [categorySearchFilter, setCategorySearchFilter] = useState({
    search: null
  })
  const [vendorSearchFilter, setVendorSearchFilter] = useState({
    search: null
  })

  const handleInventoryFiltersChange = (e) => {
    const { name, value } = e.target;
    setInventorySearchFilter((prev) => (
      {
        ...prev,
        [name]: value
      }
    ))
  }
  const handleInventorySearch = () => {
    inventoryList();
  }

  const handleCategoryFiltersChange = (e) => {
    const { name, value } = e.target;
    setCategorySearchFilter((prev) => (
      {
        ...prev,
        [name]: value
      }
    ))
  }

  const handleCategorySearch = () => {
    categoryList();
  }

  const handleVendorFiltersChange = (e) => {
    const { name, value } = e.target;
    setVendorSearchFilter((prev) => (
      {
        ...prev,
        [name]: value
      }
    ))
  }

  const handleVendorSearch = () => {
    vendorList();
  }



  const [tab, setTab] = useState(() => {
    return localStorage.getItem('inventoryTab') || 'INVENTORY';
  });

  const { id } = useParams()
  const [listCategory, setListCategory] = useState([]);
  const [listVendor, setListVendor] = useState([]);

  const [listInventory, setListInventory] = useState([])
  const [stockList, setStockList] = useState([])
  const [spinner, setSpinner] = useState(false)
  const navigate = useNavigate()
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
  })

  useEffect(() => {
    localStorage.setItem('inventoryTab', tab);

    if (tab === 'CATEGORY') {
      categoryList();
    } else if (tab === 'VENDOR') {
      vendorList();
      countryListing();
      getVendorDetails();
    } else if (tab === 'INVENTORY') {
      inventoryList();
      stockHistoryList();
      categoryFullListing();
      vendorFullListing();
    }
    return () => {
      localStorage.setItem('inventoryTab', 'INVENTORY');
    };
  }, [tab, page, pageHistory, pageCategory, pageVendor]);

  useEffect(() => {
    // If the current route is not inventory management, reset the tab
    if (!location.pathname.includes('/layout/inventoryManagement')) {
      localStorage.setItem('inventoryTab', 'INVENTORY');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (tab === 'INVENTORY' && id) {
      getInventoryDetails();
    }
  }, [id])

  useEffect(() => {
    if (selectedCountryId || (id && venderDetails.country)) {
      stateListData(selectedCountryId || venderDetails.country);
    }
  }, [selectedCountryId, id, venderDetails.country]);


  useEffect(() => {
    if (userData == null) {
      navigate('/')
    } else {
    }

  }, [])

  const [vendorFormData, setVendorFormData] = useState({
    name: "",
    category: "",
    phoneNumber: "",
    email: "",
    street: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    GSTIN: "",
    PAN: "",
    bankDetails: "",
    PaymentTerms: "",
    creditLimit: "",
    leadTime: "",
    rating: "",
    approvalStatus: "",
    remarks: "",
    taxRegistration: "",
    bankName: '',
    accountNumber: "",
    ifscSwiftCode: "",
  })

  const vendorValidationSchema = Yup.object({
    name: Yup.string().required("Vendor/Company Name is required"),
    category: Yup.string().required("Category is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    country: Yup.string().required("Country is required"),
    GSTIN: Yup.string().required("GSTIN is required"),
    rating: Yup.string().required("Rating/Score is required"),
    approvalStatus: Yup.string().required("Approval Status is required"),
    PAN: Yup.string().required("PAN is required"),
    bankName: Yup.string().required("Bank name is required"),
    accountNumber: Yup.string().required("Account number is required"),
    ifscSwiftCode: Yup.string().required("IFSC/SWIFT Code is required"),
  });

  const vendorFormik = useFormik({
    initialValues: {
      name: "",
      category: "",
      phoneNumber: "",
      email: "",
      street: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      GSTIN: "",
      PAN: "",
      bankDetails: "",
      PaymentTerms: "",
      creditLimit: "",
      leadTime: "",
      rating: "",
      approvalStatus: "",
      remarks: "",
      taxRegistration: "",
      bankName: '',
      accountNumber: "",
      ifscSwiftCode: "",
    },
    validationSchema: vendorValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      venderCreate(values);
      setSubmitting(false);
    },
  });

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleVendorChange = (e, data = null) => {
    const { name, value, type, checked } = e.target;
    if (data === 'COUNTRY') {
      vendorFormik.setFieldValue(name, value);
      setSelectedCountryId(value);
      vendorFormik.setFieldValue('state', '');
    }
    vendorFormik.setFieldValue(name, value);
    setVendorFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setVenderDetails(prev => ({
      ...prev,
      [name]: value
    }));
  }

  // const handleChangeStock = (e) => {
  //   const { name, value } = e.target
  //   setStockForm((prev) => ({
  //     ...prev,
  //     [name]: value
  //   }))
  // }

  const handleChangeStock = (e) => {
    const { name, value } = e.target;

    if (name === 'quantity') {
      const digitsOnly = value.replace(/\D/g, ''); // Remove non-digit characters

      if (digitsOnly.length > 4) return; // Ignore input if more than 4 digits

      setStockForm((prev) => ({
        ...prev,
        [name]: digitsOnly
      }));
    } else {
      // Default behavior for other fields
      setStockForm((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const [inventoryFormData, setInventoryFormData] = useState({
    productName: "",
    category: "",
    brand: "",
    unit: "",
    expireDate: "",
    mrp: "",
    purchasePrice: "",
    stockQuantity: "",
    reorderLevel: "",
    vendor: ""
  })

  const inventoryValidationSchema = Yup.object({
    productName: Yup.string().required("Product name is required"),
    category: Yup.string().required("Category is required"),
    brand: Yup.string().required("Brand manufacture is required"),
    stockQuantity: Yup.string().required("Stock quantity is required"),
    mrp: Yup.string().required("MRP is required"),
    reorderLevel: Yup.string().required("Re-order level is required"),
    purchasePrice: Yup.string().required("Purchase price is required"),
    vendor: Yup.string().required("Vendor is required"),
    expireDate: Yup.string().required("Expire date is required"),
    unit: Yup.string().required("Unit is required"),
  });

  const inventoryFormik = useFormik({
    initialValues: {
      productName: "",
      category: "",
      brand: "",
      unit: "",
      expireDate: "",
      mrp: "",
      purchasePrice: "",
      stockQuantity: "",
      reorderLevel: "",
      vendor: ""
    },
    validationSchema: inventoryValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      inventoryCreate(values);
      setSubmitting(false);
    },
  });

  const handleInventoryChange = (e) => {
    const { name, value, type, checked } = e.target;
    inventoryFormik.setFieldValue(name, value);
    setInventoryFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setInventoryDetails(prev => ({
      ...prev,
      [name]: value
    }));

  }


  const openAddModal = () => {
    setMode('add');
    setEditingId(null);
    setFormData({ name: '' });
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setMode('edit');
    setEditingId(item._id);
    setFormData({ name: item.name ?? '' });
    setShowModal(true);
  };

  const closeModalReset = () => {
    setShowModal(false);
    setMode('');
    setEditingId(null);
    setFormData({ name: '' });
  };


  const handleOpenModalMode = () => {
    if (tab === 'CATEGORY') {
      setMode('add');
      setEditingId(null);
      setFormData({ name: '' });
      setShowModal(true);
    } else if (tab === 'VENDOR') {
      navigate('/layout/inventoryManagement/add-vendor', { state: { tab: 'VENDOR' } })
    } else if (tab === 'INVENTORY') {
      navigate('/layout/inventoryManagement/add-inventory', { state: { tab: 'INVENTORY' } })
    }
  }

  const submitInventortManagement = () => {
    if (mode === 'add' && tab === 'CATEGORY') {
      categoryCreate();

    } else if ((mode === 'edit' && tab === 'CATEGORY')) {
      categoryUpdate(editingId)

    } else if (tab === 'VENDOR') {
      console.log('VENDOR');

    }
  }


  const logOutFun = () => {
    axios.post(logOutApi(), { deviceId: userData?.deviceId, userId: userData?.userId, type: userData?.roleTitle == "SERVICE_PROVIDER" ? 'WEBPROVIDER' : 'WEBSTAFF' }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        localStorage.removeItem('userData')
        navigate('/')
      }
    })
  }

  const categoryCreate = () => {
    const createObject = {
      name: formData.name,
      branchId: userData?.locationId
    }
    axios.post(categoryCreateAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message || 'Added category successfully');
        categoryList()
        closeModalReset();
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const categoryUpdate = (id) => {
    const createObject = {
      id: id,
      name: formData.name
    }

    axios.post(categoryUpdateAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message || 'Updated category successfully');
        categoryList()
        closeModalReset()
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const categoryList = () => {
    setSpinner(true);
    const payload = {
      page: pageCategory,
      count: PER_PAGE,
      search: categorySearchFilter.search !== null ? categorySearchFilter.search : null,
      branchId: userData?.locationId
    }
    axios.post(categoryListAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setListCategory(resp.data.data);
        setCategoryCount(resp.data.totalCount)
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const categoryDelete = (id) => {
    setSpinner(true);
    const payload = {
      id: id,
      isDeleted: true
    }
    axios.post(categoryDeleteAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message || 'Deleted category successfully');
        categoryList()
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => {
      setSpinner(false);
      toast.error("Error deleting category");
    });
  }

  const categoryChangeStatusApi = (id, currentStatus) => {
    const createObject = {
      id: id,
      isActive: !currentStatus,
    }
    axios.post(categoryChangeStatusAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message);
        categoryList()
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }


  //  vender api's  

  const venderCreate = (values) => {

    const createObject = {
      name: values.name,
      category: values.category,
      phoneNumber: values.phoneNumber,
      email: values.email,
      street: values.street,
      city: values.city,
      state: values.state,
      postalCode: values.postalCode,
      country: values.country,
      GSTIN: values.GSTIN,
      PAN: values.PAN,
      bankDetails: values.bankDetails,
      PaymentTerms: values.PaymentTerms,
      creditLimit: values.creditLimit,
      leadTime: values.leadTime,
      rating: values.rating,
      approvalStatus: values.approvalStatus,
      remarks: values.remarks,
      taxRegistration: values.taxRegistration,
      bankName: values.bankName,
      accountNumber: values.accountNumber,
      ifscSwiftCode: values.ifscSwiftCode,
      branchId: userData?.locationId

    }
    axios.post(vendorCreateAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message || 'Added category successfully');
        setTimeout(() => {
          vendorList();
          vendorFormik.resetForm();
          setVendorFormData({});
          navigate(-1);
          closeModalReset();
          setSpinner(false);
        }, 1000);
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const vendorList = () => {
    const payload = {
      page: pageVendor,
      count: PER_PAGE,
      search: vendorSearchFilter.search !== null ? vendorSearchFilter.search : null,
      branchId: userData?.locationId
    }
    setSpinner(true);
    axios.post(vendorListAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setListVendor(resp.data.data);
        setVendorCount(resp.data.totalCount)
        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const getVendorDetails = () => {

    setSpinner(true);
    const payload = {
      id: id
    }

    axios.post(vendorDetailsAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setVenderDetails(resp.data.data);
        setSelectedCountryId(resp.data.data.country);
        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const vendorUpdate = (id, values) => {

    const requiredFields = [
      'name', 'category', 'phoneNumber', 'country', 'GSTIN',
      'rating', 'PAN', 'bankName', 'accountNumber', 'ifscSwiftCode',
    ];

    const emptyFields = requiredFields.filter(field => !values[field]);

    if (emptyFields.length > 0) {
      toast.error(`Please fill all required fields: ${emptyFields.join(', ')}`);
      return;
    }

    const payload = {
      id: id,
      name: values.name,
      category: values.category,
      phoneNumber: values.phoneNumber,
      email: values.email,
      street: values.street,
      city: values.city,
      state: values.state,
      postalCode: values.postalCode,
      country: values.country,
      GSTIN: values.GSTIN,
      PAN: values.PAN,
      bankDetails: values.bankDetails,
      PaymentTerms: values.PaymentTerms,
      creditLimit: values.creditLimit,
      leadTime: values.leadTime,
      rating: values.rating,
      approvalStatus: values.approvalStatus,
      remarks: values.remarks,
      taxRegistration: values.taxRegistration,
      bankName: values.bankName,
      accountNumber: values.accountNumber,
      ifscSwiftCode: values.ifscSwiftCode,
    }
    setSpinner(true);
    axios.post(vendorUpdateAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message);
        setTimeout(() => {
          vendorList();
          navigate(-1);
          setSpinner(false);
        }, 1000);

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message);
      }
    }).catch(() => { })
  }

  const vendorDelete = (id) => {
    setSpinner(true);
    const payload = {
      id: id,
      isDeleted: true,
    }
    axios.post(vendorDeleteAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message);
        vendorList();
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message);
      }
    }).catch(() => { })
  }

  const categoryFullListing = () => {
    setSpinner(true);
    axios.post(categoryFullListAPI(), {}, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setCategoryFullList(resp.data.data);
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const vendorFullListing = () => {

    setSpinner(true);
    axios.post(vendorFullListAPI(), {}, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setVedndorFullList(resp.data.data);
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const countryListing = () => {
    setSpinner(true);
    axios.post(countryListApi(), {
      isActive: true, isDeleted: false
    }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setCountryList(resp.data.data);
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const stateListData = (id) => {
    axios
      .post(stateListApi(), { countryId: id, sortValue: 'name', sortOrder: -1, page: 1, count: 200 })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setStateList(resp.data.data)
        }
      }).catch(() => { })
  }

  const vendorChangeStatusApi = (id, currentStatus) => {
    const createObject = {
      id: id,
      isActive: !currentStatus,
    }
    axios.post(vendorChangeStatusAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message);
        vendorList()
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  //  inventory api's  

  const inventoryCreate = (values) => {

    const createObject = {
      productName: values.productName,
      category: values.category,
      brand: values.brand,
      unit: values.unit,
      expireDate: values.expireDate,
      mrp: values.mrp,
      purchasePrice: values.purchasePrice,
      stockQuantity: values.stockQuantity,
      reorderLevel: values.reorderLevel,
      vendor: values.vendor,
      branchId: userData?.locationId
    }

    axios.post(inventoryCreateAPI(), createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message || 'Added inventory successfully');
        setTimeout(() => {
          inventoryList();
          inventoryFormik.resetForm();
          setVendorFormData({});
          navigate(-1);
          closeModalReset();
          setSpinner(false);
        }, 1000);
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
    toast.error(resp?.data?.message || 'Something went wrong');
      }
    }).catch(() => { })
  }

  const inventoryList = () => {
    const payload = {
      page: page,
      count: PER_PAGE,
      search: inventorySearchFilter.search !== null ? inventorySearchFilter.search : null,
      branchId: userData?.locationId
    }
    setSpinner(true);
    axios.post(inventoryListAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setListInventory(resp.data.data);
        setCount(resp.data.totalCount)
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const getInventoryDetails = () => {
    setSpinner(true);
    axios.get(inventoryGetAPI(id), { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setInventoryDetails(resp.data.data);
        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

const updateInventory = (id, values) => {
  const requiredFields = [
    'productName', 'category', 'brand', 'unit', 'expireDate',
    'mrp', 'purchasePrice', 'stockQuantity', 'reorderLevel', 'vendor'
  ];

  const emptyFields = requiredFields.filter(field => !values[field]);

  if (emptyFields.length > 0) {
    toast.error(`Please fill all required fields: ${emptyFields.join(', ')}`);
    return;
  }

  setSpinner(true); // Spinner only shown if validation passes

  const payload = {
    productName: values.productName,
    category: values.category,
    unit: values.unit,
    expireDate: values.expireDate,
    mrp: values.mrp,
    purchasePrice: values.purchasePrice,
    stockQuantity: values.stockQuantity,
    reorderLevel: values.reorderLevel,
    brand: values.brand,
    vendor: values.vendor,
    _id: id
  };

  axios.post(inventoryUpdateAPI(), payload, {
    headers: { Authorization: `Bearer ${userData?.token}` }
  }).then((resp) => {
    if (resp.data.code === statusCodes.ok) {
      toast.success(resp.data.message || 'Updated Inventory successfully');
      setTimeout(() => {
        inventoryList();
        navigate(-1);
        setSpinner(false);
      }, 1000);
    } else if (resp.data.code === statusCodes.tokenExpire) {
      logOutFun();
    } else {
      toast.error(resp?.data?.message || 'Something went wrong');
      setSpinner(false);
    }
  }).catch((error) => {
    toast.error(error?.response?.data?.message || 'Something went wrong');
    setSpinner(false);
  });
};

  const updateStock = () => {

    setSpinner(true);
    const payload = {
      _id: stockModal.inventoryId,
      action: stockModal.action,
      quantity: stockForm.quantity,
    }

    axios.put(inventoryUpdateStockAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message)
        inventoryList()
        setSpinner(false)
        setStockForm({ quantity: '' });
        setStockModal({ show: false, inventoryId: '', action: '' });
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { setSpinner(false); })
  }

  const stockHistoryList = () => {
    const payload = {
      page: pageHistory,
      count: PER_PAGE,
      id: id,
    }
    setSpinner(true);
    axios.post(StockHistoryListAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        setStockList(resp.data.data);
        setHistoryCount(resp.data.totalCount)
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const inventoryDownload = () => {
    setSpinner(true);
    axios.post(inventoryDownloadList(), {}, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        if (resp.data.data.success) window.open(`${environment.baseUrl}/upload/export/${resp.data.data.excelName}`)
        else toast.success("No data available for download excel")

        setSpinner(false)
      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {

      }
    }).catch(() => { })
  }

  const inventoryDelete = (id) => {
    setSpinner(true);
    const payload = {
      _id: id,
      isDeleted: true,
    }
    axios.post(inventoryDeleteAPI(), payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        toast.success(resp.data.message);
        inventoryList();
        setSpinner(false)

      }
      else if (resp.data.code === statusCodes.tokenExpire) {
        logOutFun()
      }
      else {
        toast.error(resp.data.message);
      }
    }).catch(() => { })
  }


  return {
    setShowModal,
    openAddModal,
    openEditModal,
    setTab,
    submitInventortManagement,
    categoryCreate,
    handleChange,
    handleOpenModalMode,
    categoryDelete,
    categoryChangeStatusApi,
    categoryUpdate,
    handleVendorChange,
    venderCreate,
    stateListData,
    vendorDelete,
    getVendorDetails,
    vendorChangeStatusApi,
    vendorUpdate,
    setPage,
    handleInventoryChange,
    updateInventory,
    getInventoryDetails,
    setStockModal,
    handleChangeStock,
    updateStock,
    setPageHistroy,
    setPageCategory,
    setPageVendor,
    inventoryDownload,
    inventoryDelete,
    handleInventoryFiltersChange,
    handleInventorySearch,
    handleCategoryFiltersChange,
    handleCategorySearch,
    handleVendorFiltersChange,
    handleVendorSearch,
    vendorSearchFilter,
    categorySearchFilter,
    inventorySearchFilter,
    pageVendor,
    vendorCount,
    categoryCount,
    showModal,
    mode,
    editingId,
    tab,
    formData,
    listCategory,
    spinner,
    listVendor,
    vendorFormData,
    categoryFullList,
    stateList,
    countryList,
    vendorFormik,
    venderDetails,
    count,
    page,
    PER_PAGE,
    pageHistory,
    historyCount,
    inventoryFormData,
    inventoryFormik,
    vendorFullList,
    listInventory,
    inventoryDetails,
    stockModal,
    stockForm,
    stockList
  }

}

export default useInventoryManagement;